import _ from 'lodash';

import { jsonParse } from 'utils/json';

import { formatDateTime } from '../../LoanClosingCDS.utils';

import {
  ScheduleClosingLocationLabel,
  ScheduleClosingTaskStatusLabel,
} from './ScheduleClosingSection.constants';

export const parseScheduleClosingMetadata = metadata => {
  if (_.isNil(metadata)) {
    return null;
  }

  try {
    return _.isString(metadata) ? jsonParse(metadata) : metadata;
  } catch {
    return null;
  }
};

export const getScheduleClosingLocationLabel = location =>
  ScheduleClosingLocationLabel[location] || location || '-';

export const getScheduleClosingStatusLabel = status =>
  ScheduleClosingTaskStatusLabel[status] || status || '-';

export const formatSlotDateTime = slot => {
  if (_.isNil(slot?.date)) {
    return '-';
  }

  const dateStr = formatDateTime(slot.date);

  return slot.time ? `${dateStr} at ${slot.time}` : dateStr;
};

export const getFormattedAddress = metadata => {
  const address = metadata?.locationDetails?.address;
  const description = metadata?.locationDetails?.description;

  if (!address && !description) {
    return '-';
  }

  return [address, description].filter(Boolean).join(' — ');
};
